import { Form, InputGroup } from "react-bootstrap";

import GenericFormGroup from "./GenericFormGroup";

const AreaBuilderNumberFormGroup = (props) => {
    return (
        <GenericFormGroup
            {...props}
            distribution={props?.distribution || [6, 6]}
            renderInput={(field, _canResetToDefault, errorMessage) => (
                <>
                    <Form.Control
                        type={props.canBeText ? "text" : "number"}
                        step={props.step ?? 1}
                        {...field}
                        isInvalid={!!errorMessage}
                    />
                    {props.unitText && (
                        <InputGroup.Text>{props.unitText}</InputGroup.Text>
                    )}
                </>
            )}
        />
    );
};

export default AreaBuilderNumberFormGroup;
